import { FC } from 'react';
import { Link, LinkProps } from 'dibs-elements/exports/Link';

type Props = {
    wrapperClass?: string;
    linkClass?: string;
    linkType?: LinkProps['buyerLinkType'];
};

const RecaptchaTerms: FC<Props> = ({ wrapperClass, linkClass, linkType }) => {
    return (
        <div className={wrapperClass}>
            This site is protected by reCAPTCHA and the Google{' '}
            <Link
                href="https://policies.google.com/privacy"
                target="_blank"
                underline="underline"
                className={linkClass}
                buyerLinkType={linkType}
            >
                Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
                href="https://policies.google.com/terms"
                target="_blank"
                underline="underline"
                className={linkClass}
                buyerLinkType={linkType}
            >
                Terms of Service
            </Link>{' '}
            apply.
        </div>
    );
};

export default RecaptchaTerms;
